{
	"language": {
		"select": "言語を選択",
		"sectionTitle": "言語",
		"changeSuccess": "言語が変更されました"
	},
	"assistant": {
		"composer": {
			"placeholder": "{{assistantName}}に質問",
			"disclaimer": "{{assistantName}}は間違えることがあります。重要な情報はご確認ください。"
		},
		"greeting": {
			"initialMessage": "👋 こんにちは！**{{assistantName}}**学習アシスタントです。**{{context}}**の準備をしっかりサポートします。**{{topic}}**について回答した問題を詳しく見ていきましょう。",
			"starter": "こんにちは、**{{assistantName}}**です。何かお手伝いしましょうか？"
		},
		"chips": {
			"askYourOwn": "自分で質問する",
			"askFollowUp": "追加の質問をする"
		},
		"emptyState": {
			"title": "{{assistantName}}はあなたのAI学習アシスタントです",
			"contextSubtitle": "{{context}}について何でも質問してください",
			"activateSubtitle": "{{assistantName}}は質問に回答すると利用できるようになります"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "クイック学習",
			"examInfo": {
				"subtitle": {
					"setExamDate": "試験日を設定",
					"examDateWithValue": "試験日: <date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "改善の余地あり",
				"itsAwesome": "素晴らしい"
			},
			"title": "お疲れ様でした！",
			"body": "学習への取り組みを見ていて嬉しいです！アプリの体験はいかがですか？ご感想をシェアして、レビューを残していただけませんか？",
			"cta": "後で"
		},
		"actions": {
			"studyWeak": "弱点分野を練習",
			"viewProgress": "進捗を表示",
			"seeRank": "ランキングを見る",
			"seeRankings": "リーダーボードを見る",
			"unlock": "プレミアムコンテンツをアンロック",
			"unlockTooltip": "プレミアムコンテンツをアンロックすることで、限定機能と上級学習教材にアクセスできます",
			"startCustomSession": "カスタムセッションを開始",
			"startCustomSessionTooltip": "あなたの学習に焦点を当てたカスタムセッションを開始します",
			"takeDiagnostic": "診断テストを受ける",
			"takeDiagnosticTooltip": "診断テストを受けて現在のレベルを評価し、それに応じて学習計画をカスタマイズします",
			"viewDiagnostic": "診断結果を見る",
			"viewDiagnosticTooltip": "診断結果を確認して、強みと改善が必要な分野を理解します",
			"viewPodcasts": "ポッドキャストを聴く",
			"viewPodcastsTooltip": "教育ポッドキャストにアクセスして、学習体験を向上させます",
			"upgradeToPremium": "プレミアムにアップグレード",
			"upgradeToPremiumTooltip": "プレミアムにアップグレードして、すべてのコンテンツと機能にアクセスします",
			"extendAccess": "アクセスを延長",
			"extendAccessTooltip": "プレミアムコンテンツへのアクセスを延長します",
			"setExamDate": "試験日を設定",
			"setExamDateTooltip": "試験日を設定して進捗を追跡し、試験の準備をします"
		},
		"exam": {
			"daysAgo_one": "{{count}}日前",
			"daysAgo_other": "{{count}}日前",
			"untilExam_one": "試験まであと{{count}}日",
			"untilExam_other": "試験まであと{{count}}日",
			"isToday": "試験は今日です！"
		},
		"stats": {
			"mastery": "習熟度",
			"completed_one": "解答済みアイテム",
			"completed_other": "解答済みアイテム",
			"completedValue": "{{count}}",
			"xpEarned": "獲得XP",
			"xpEarnedValue": "{{value}}",
			"accuracy": "正答率",
			"accuracyValue": "{{value}}%",
			"skillLevelTooltip": "あなたの{{skill}}の推定習熟度は「{{level}}」です",
			"itemsAnsweredTooltip": "これまでに解答した問題の合計数です",
			"responsesAnsweredTooltip": "これまでに送信した解答の合計数です",
			"examDateTooltip": "試験日は{{date}}です",
			"skillCta": {
				"diagnostic": "診断",
				"practice": "練習"
			}
		},
		"menu": {
			"settings": "設定",
			"profile": "プロフィール"
		},
		"diagnostics": {
			"title": "診断テスト",
			"free": "無料",
			"duration": "{{count}}個の{{item}} • {{minutes}}分",
			"completed": "{{count}}個の{{item}}完了",
			"start": "開始",
			"viewReport": "レポートを見る",
			"resume": "再開"
		},
		"practiceTests": {
			"title": "模擬試験",
			"sectionalTestsTitle": "セクション別テスト",
			"diagnosticAssessmentsTitle": "診断テスト",
			"premiumChipTooltip": "{{examName}}試験向けの本格的なプレミアム模擬試験",
			"freeChipTooltip": "{{examName}}試験向けの{{label}}",
			"freeChipTooltipDefault": "{{examName}}試験向けの無料診断テスト",
			"completedDescription_one": "{{count}}問 • {{date}}",
			"completedDescription_other": "{{count}}問 • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}}問 • 残り{{timeRemaining}}",
			"activeDescription_other": "{{attempted}}/{{count}}問 • 残り{{timeRemaining}}",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}}問 • 残り{{timeRemaining}} • 開始日: {{startedOn}} • 終了日: {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}}問 • 残り{{timeRemaining}} • 開始日: {{startedOn}} • 終了日: {{endsOn}}",
			"notStartedDescription_one": "{{count}}問 • {{duration}}",
			"notStartedDescription_other": "{{count}}問 • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}}問 • {{duration}} • 終了日: {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}}問 • {{duration}} • 終了日: {{endsOn}}",
			"viewResultsCta": "結果を見る",
			"startCta": "開始",
			"chips": {
				"items_one": "{{count}}問",
				"items_other": "{{count}}問",
				"progress_one": "{{attempted}}/{{count}}問",
				"progress_other": "{{attempted}}/{{count}}問",
				"timeRemaining": "残り{{time}}",
				"startedOn": "開始日: {{date}}",
				"endsOn": "終了日: {{date}}",
				"timeLeft": "残り{{time}}"
			},
			"status": {
				"notStarted": {
					"label": "未開始",
					"section": "本格的な模擬試験"
				},
				"inProgress": {
					"label": "進行中",
					"section": "進行中"
				},
				"completed": {
					"label": "完了",
					"section": "完了"
				},
				"legacyReports": {
					"label": "旧レポート",
					"section": "旧レポート"
				},
				"migratedReports": {
					"label": "移行済みレポート",
					"section": "移行済みレポート"
				}
			}
		},
		"skills": {
			"title": "スキル",
			"unlockSubtitle": "練習するにはプレミアムをアンロック",
			"startCta": "練習",
			"freeItemsIncludedChip": "無料アイテムを含む",
			"freeItemsAnsweredSubtitle_one": "無料アイテム{{count, number}}個中{{answered, number}}個解答済み",
			"freeItemsAnsweredSubtitle_other": "無料アイテム{{count, number}}個中{{answered, number}}個解答済み",
			"proficiencySection": "熟練度別に練習",
			"progressCards": {
				"questionTypesTitle": "問題タイプ別の成績",
				"questionTypesSubtitle": "{{skill}} の問題タイプ別スコア",
				"proficiencyTitle": "熟練度別の成績",
				"proficiencySubtitle": "{{skill}} の各レベルの進捗",
				"questionTypeCardSubtitle": "熟練度別の進捗",
				"bySkillTitle": "スキル別の成績",
				"bySkillSubtitle": "スキル全体の進捗",
				"needsImprovementTitle": "要改善",
				"needsImprovementSubtitle": "次に集中すべきスキル",
				"skillPerformanceTitle": "{{skill}} の成績",
				"skillPerformanceSubtitle": "問題タイプと熟練度別の進捗",
				"skillLevelSubtitle": "このスキルレベルでの進捗状況",
				"skillsPerformanceTitle": "スキル別の成績",
				"performanceByItemDifficulty": "習熟度別の成績",
				"performanceByItemDifficultyCaption_one": "習熟度別の正答率を表示します(解答した{{count}}問に基づく)",
				"performanceByItemDifficultyCaption_other": "習熟度別の正答率を表示します(解答した{{count}}問に基づく)",
				"questionTypePartSubtitle": "{{skill}} · パート{{part}}",
				"activityGoalTitle": "アクティビティと目標の進捗",
				"recentActivityTitle": "最近のアクティビティ",
				"goalProgressTitle": "目標の進捗",
				"goalProgressSubtitle": "総合スコア · 過去7週間",
				"goalProgressInsight": "順調に伸びています。目標まであと14ポイントで、約3週間で到達できる見込みです。",
				"goalProgressActualLabel": "あなたのスコア",
				"goalProgressTargetLabel": "目標",
				"goalProgressTimeAxisLabel": "期間",
				"goalProgressScoreAxisLabel": "総合進捗",
				"statusTitle": "現在のステータス",
				"diagnosticsTitle": "診断",
				"diagnosticsReviewCta": "確認",
				"strengthsFocusTitle": "強みと重点分野",
				"strengthsFocusSubtitle": "最も得意な分野と、さらに練習が必要な問題タイプ",
				"strengthsLabel": "強み",
				"focusAreasLabel": "重点分野",
				"recommendedNextStepLabel": "次のおすすめステップ",
				"recommendedNextStepCta": "開始",
				"practiceTestsViewMore": "すべての{{count}}件のテストを表示"
			}
		},
		"recommendedTasks": {
			"sectionTitle": "あなたへのおすすめ",
			"startSessionAction": "練習",
			"resumeAction": "再開",
			"reviewResultsAction": "結果を確認",
			"startTestAction": "テストを開始",
			"activeTestBody": "進行中の評価を完了する",
			"completedTestBody": "成績と回答を確認する",
			"diagnosticBody": "{{label}}を受けて試験形式に慣れましょう",
			"diagnosticDefaultLabel": "無料診断テスト",
			"practiceTestBody": "時間制限のあるテストで試験準備状況を評価しましょう。",
			"sectionalTestBody": "{{skills}}スキルを練習するための集中テストを受けましょう。",
			"weakSkillTitle": "{{skill}}を伸ばそう",
			"weakSkillBody": "{{questionType}}の練習。まだ習得していない部分を重点的に。",
			"strongSkillTitle": "{{skill}}をキープ",
			"strongSkillBody": "ここは得意分野。短い{{questionType}}セットで維持しましょう。",
			"mixedSkillTitle": "{{skill}}をバランスよく",
			"mixedSkillBody": "{{questionTypes}}を混ぜたセット。取りこぼしを重点的に。",
			"higherDifficultySkillTitle": "{{proficiency}}にステップアップ",
			"higherDifficultySkillBody": "このレベルの{{questionType}}はクリア済み。もう一段階難しい問題です。",
			"itemsChip_one": "{{count}}問",
			"itemsChip_other": "{{count}}問",
			"timeRemainingChip": "残り{{minutes}}分",
			"timeRemainingChipCompact": "{{minutes}}分"
		},
		"itemTypes": {
			"answeredLabel_one": "解答済み",
			"answeredLabel_other": "解答済み",
			"answeredAll": "全て",
			"answeredPartial": "{{total}}問中{{answered}}問",
			"cardSubtitleComplete": "全問解答済み",
			"cardSubtitlePartial": "{{total}}問中{{attempted}}問解答済み",
			"cardSubtitleResponses_one": "{{count}}回解答済み",
			"cardSubtitleResponses_other": "{{count}}回解答済み",
			"responsesLabel_one": "解答数",
			"responsesLabel_other": "解答数",
			"detail": {
				"skillLabel": "スキル",
				"estimatedLevelLabel": "推定レベル"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}}{{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}}{{label, lowercase}}",
			"responseCount_one": "{{count, number}}回解答済み",
			"responseCount_other": "{{count, number}}回解答済み"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "無料の練習アイテムが{{count, number}}個含まれています",
			"freeContentBannerTitle_other": "無料の練習アイテムが{{count, number}}個含まれています",
			"freeContentBannerBody": "{{skills}}の練習アイテムはいつでも利用できます。アップグレードしてスタディパック全体をアンロックしましょう。",
			"freeContentBannerCta": "無料の練習を始める",
			"freeSampleBanner": {
				"body_one": "{{categories}}の練習アイテムはいつでも利用できます。アップグレードしてあと{{count, number}}個のアイテムをアンロックしましょう。",
				"body_other": "{{categories}}の練習アイテムはいつでも利用できます。アップグレードしてあと{{count, number}}個のアイテムをアンロックしましょう。",
				"moreTags": "あと{{count, number}}個の{{label}}",
				"cta": "アップグレード"
			}
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "他の人と比較してあなたの成績を見る"
		},
		"home": {
			"title": "ホーム"
		},
		"podcasts": {
			"description": "専門家による整形外科のポッドキャストを聴く。"
		},
		"more": {
			"title": "その他の設定"
		}
	},
	"emptyState": {
		"progress": {
			"title": "学習進捗がありません",
			"subtitle": "学習すると、進捗がここに表示されます",
			"cta": "今すぐ学習"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "エラー",
			"body": "セッション作成に失敗しました。もう一度お試しください"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "上級",
			"highIntermediate": "中級",
			"intermediate": "中級",
			"basic": "基礎",
			"none": "未回答",
			"high": "習得済み",
			"medium": "習得に近い",
			"low": "練習が必要"
		}
	},
	"leaderboard": {
		"you": "これはあなたです",
		"periods": {
			"all_time": "全期間",
			"month": "今月",
			"week": "今週"
		},
		"scope": {
			"global": "全体",
			"friends": "フレンド"
		},
		"friends": {
			"soon": "近日公開",
			"comingSoonTitle": "フレンドランキング",
			"comingSoonBadge": "近日公開",
			"comingSoonDescription": "フレンドと進捗を比べて、誰がトップかを確認しよう。"
		},
		"error": {
			"title": "接続エラー",
			"description": "ランキングを読み込めませんでした。接続を確認してもう一度お試しください。",
			"tryAgain": "再試行"
		},
		"empty": {
			"title": "まだランキングがありません",
			"description": "学習を始めて、ランキングのトップを目指しましょう。",
			"startLearning": "学習を始める"
		},
		"topPerformers": "トップ",
		"yourPosition": "あなたの順位",
		"rankings": "ランキング",
		"rankingsRange": "ランキング • {{startRank}}位〜{{endRank}}位",
		"unranked": {
			"title": "XPを獲得してランキングに参加しよう！",
			"description": "学習セッションを始めて最初のポイントを獲得し、ランキングに載りましょう。",
			"cta": "最初のセッションを始める"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "YOU",
		"podium": {
			"first": "1位",
			"second": "2位",
			"third": "3位"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>#{{rank}}位を超えるには</rest>",
			"gapHintFromPodium": "<num>+{{value}}</num><unit> XP</unit> <rest>表彰台まで</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "レッスン",
			"statusFilter": {
				"all": "すべて",
				"inProgress": "進行中",
				"notStarted": "未開始",
				"completed": "完了"
			},
			"card": {
				"openCta": "開く",
				"resumeCta": "再開",
				"viewResultsCta": "結果を見る",
				"duration_one": "{{count}}分",
				"duration_other": "{{count}}分"
			},
			"viewToggle": {
				"list": "リスト表示",
				"grid": "グリッド表示"
			},
			"empty": {
				"filteredTitle": "このフィルターに一致するレッスンはありません",
				"filteredSubtitle": "別のステータスフィルターをお試しください",
				"filteredCta": "すべて表示",
				"noneTitle": "レッスンが見つかりません",
				"noneSubtitle": "フィルターを解除するか、新しい検索をお試しください",
				"noneCta": "すべてリセット"
			}
		},
		"home": {
			"hero": {
				"greeting": "ようこそ、{{name}}さん！",
				"greetingNoName": "ようこそ！"
			},
			"stats": {
				"modulesDone": "完了したモジュール",
				"dayStreak": "連続日数",
				"minutesToday": "今日の分数"
			},
			"suggested": {
				"title": "あなたへのおすすめ",
				"openModuleCta": "モジュールを開く",
				"status": {
					"ready": "準備完了",
					"next": "次へ"
				}
			},
			"all": {
				"title": "すべてのレッスン"
			},
			"emptyState": {
				"title": "レッスンはまだありません",
				"subtitle": "新しいレッスンをお待ちください。"
			},
			"card": {
				"duration_one": "{{count}}分",
				"duration_other": "{{count}}分"
			}
		},
		"overview": {
			"header": {
				"title": "概要"
			},
			"startCta": "学習を始める",
			"objectives": {
				"title": "学習目標"
			}
		},
		"detail": {
			"takeQuizCta": "クイズに挑戦",
			"progress": {
				"label": "モジュールの進捗"
			},
			"activities": {
				"title": "アクティビティ",
				"completedCount": "{{total}}件中{{completed}}件完了"
			},
			"artifact": {
				"startCta": "Start",
				"resumeCta": "Resume",
				"reviewCta": "Review",
				"listenAgainCta": "Listen again",
				"readAgainCta": "Read again"
			},
			"tabs": {
				"content": "Content",
				"insights": "Insights",
				"cme": "CME"
			}
		},
		"stats": {
			"insights": {
				"title": "進捗インサイト"
			},
			"milestones": {
				"title": "モジュールのマイルストーン",
				"startCta": "Start"
			}
		},
		"studyGuide": {
			"progress": {
				"label": "読了"
			},
			"readTime": "読了目安 {{count}} 分",
			"sectionBadge": {
				"label": "セクション {{number}}/{{total}}"
			},
			"upNext": {
				"title": "次はこちら"
			}
		},
		"cme": {
			"notStarted": {
				"title": "Start earning CME for this module",
				"description": "You haven't started this module yet. Complete the required activities to begin earning credit toward your certificate.",
				"cta": "Start learning"
			},
			"inProgress": {
				"title": "CME in progress",
				"description": "Complete all required activities to earn your CME credits and generate your certificate",
				"cta": "Continue learning"
			},
			"incompleteFootnote": "Certificates are only available after all CME requirements have been fulfilled. Partial completion does not qualify for credit.",
			"ready": {
				"completedOn": "Completed {{date}}",
				"title": "Certificate ready, {{credits}} credits earned",
				"description": "You've completed all required activities for this module.",
				"creditTableCaption": "What earned this credit",
				"downloadCta": "Download PDF",
				"redownloadCta": "Re-download PDF",
				"emailCta": "Email me",
				"downloadNotice": "You already downloaded a certificate for this module on {{date}}.",
				"downloadNoticeLink": "See that certificate",
				"footnote": "This credit will also be added to your total CME balance."
			}
		}
	},
	"sessionConfig": {
		"title": "カスタム学習セッション",
		"diagnostic": "診断テスト",
		"skill": "スキル",
		"Proficiency": "熟練度",
		"Question Type": "問題タイプ",
		"mastery": "習熟度",
		"sessionLength": "セッションの長さ",
		"itemsChip_one": "{{count}}問",
		"itemsChip_other": "{{count}}問",
		"durationEstimate": "{{minutes}}分",
		"durationRange": "{{min}}–{{max}}分",
		"noItemsTooltip": "現在のフィルターに一致する項目がありません",
		"setCount": "{{count}}個の{{type}}",
		"dismiss": "OK",
		"status": {
			"notAnswered": "未回答",
			"needsWork": "練習が必要"
		},
		"itemCount": "{{topics}}つのトピックで{{count}}個の問題を完了します",
		"start": "開始",
		"configuringSession": "セッションを設定中...",
		"fetchingContent": "コンテンツを取得中...",
		"preparingMaterials": "教材を準備中...",
		"almostThere": "もうすぐ完了...",
		"startingSession": "セッションを開始中...",
		"playIcon": "play-outline",
		"infoText": "**{{numItems}}**個の{{itemCount}}を完了します。これには約**{{timeString}}**かかります。",
		"customSummary": {
			"message": "{{topics}}から$t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}})を学習します。",
			"messageWithMastery": "{{topics}}から$t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}})を学習し、$t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}}){{masteryLevels}}に重点を置きます。",
			"messageAllMasteryLevels": "{{topics}}から、すべての習熟度にわたって$t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}})を学習します。",
			"itemCount_one": "{{count}}個の項目",
			"itemCount_other": "{{count}}個の項目",
			"masteryLevelCount_one": "習熟度",
			"masteryLevelCount_other": "習熟度",
			"allTopics": "全{{count}}トピック",
			"more": "ほか{{count}}件",
			"quotedMasteryLevel": "「{{masteryLevel}}」"
		},
		"quickStudy": {
			"title": "クイック学習",
			"recommended": "おすすめ",
			"custom": "カスタム",
			"selectHelper": "セッションを選択してから開始してください。",
			"emptyRecommended": "現在おすすめのセッションはありません。",
			"summary": "{{skill}}から{{count}}個の項目を学習します。目安は{{minutes}}分です。",
			"summary_questionType": "{{skill}}、{{questionType}}から{{count}}個の項目を学習します。目安は{{minutes}}分です。",
			"duration": "{{minutes}}分",
			"durationSelector": {
				"title": "所要時間"
			},
			"levelSessions": {
				"rapidRecall": "クイック復習",
				"purposefulPractice": "集中練習",
				"focusFlow": "フォーカスフロー",
				"itemsLabel": "{{level}}の項目",
				"itemsLabelGeneric": "項目",
				"summaries": {
					"rapidRecall": "まだ解答していない{{level}}の項目{{count}}個に触れて、着実に学習範囲を広げます。目安は{{minutes}}分です。",
					"purposefulPractice": "{{level}}の項目{{count}}個をバランスよく学習し、最も強化が必要な内容から始めます。目安は{{minutes}}分です。",
					"focusFlow": "習熟度が低い{{level}}の項目{{count}}個を集中的に復習し、弱点を強化します。目安は{{minutes}}分です。"
				},
				"summariesGeneric": {
					"rapidRecall": "まだ解答していない項目{{count}}個に触れて、着実に学習範囲を広げます。目安は{{minutes}}分です。",
					"purposefulPractice": "項目{{count}}個をバランスよく学習し、最も強化が必要な内容から始めます。目安は{{minutes}}分です。",
					"focusFlow": "習熟度が低い項目{{count}}個を集中的に復習し、弱点を強化します。目安は{{minutes}}分です。"
				}
			},
			"lockedOptionsBanner": "Unlock {{names}} with Premium",
			"lockedOptionsBannerOverflow": "Unlock {{names}} and {{count}} more with Premium"
		}
	},
	"skillDetail": {
		"diagnosticInsight": "学習体験をパーソナライズするために、まずは診断クイズから始めましょう。診断結果はあなたの学習プランの作成に使用されます。"
	},
	"premium": {
		"chip": "プレミアム",
		"upgrade": "プレミアムにアップグレード",
		"unlockTitle": "{{productName}} の完全体験を解鎖",
		"unlockDescription": "残りの学習時間に合わせて設計された、パーソナライズされた練習を解鎖しましょう。",
		"readyTitle": "{{date}}の試験に備えましょう",
		"tip": "あなた専用のフォーカス:プレミアムが次に練習すべき内容を特定し、上達に合わせて学習プランを調整します。"
	},
	"purchase": {
		"success": {
			"headerTitle": "ご購入ありがとうございます！",
			"accessGranted": "{{name}}へのアクセスが正常に許可されました",
			"studyPack": "スタディパック",
			"practiceTest": "模擬試験",
			"combo": "コンボ",
			"documentTitle": "購入",
			"summary_one": "おめでとうございます！以下の**製品**がアカウントでロック解除されました。{{action}}を押すと、アプリのコンテキストが試験 **{{examName}}** に変更されます。別の試験の学習や別の製品の購入を希望する場合は、アカウント設定からいつでも変更できます。",
			"summary_other": "おめでとうございます！以下の **{{count}} 製品** がアカウントでロック解除されました。{{action}}を押すと、アプリのコンテキストが試験 **{{examName}}** に変更されます。別の試験の学習や別の製品の購入を希望する場合は、アカウント設定からいつでも変更できます。",
			"unlockedDuration": "おめでとうございます！**{{name}}** への **{{duration}}** のアクセスが有効になりました。**{{expiry}}** に終了します。",
			"storeNote": "注意：スタディパックはモバイルアプリからのみ利用できます。お使いのデバイスに合ったアプリをダウンロードしてください。",
			"actions": {
				"goToHome": "ホームへ移動",
				"startDiagnostic": "{{label}}を開始",
				"takeDiagnostic": "{{label}}を受ける",
				"takeFreeDiagnostic": "無料診断テストを受ける",
				"diagnosticLabel": "診断テスト"
			}
		},
		"checkout": {
			"headerTitle": "購入を完了"
		},
		"paywall": {
			"studyPackDialogTitle": "学習プランをアップグレード",
			"defaultDialogTitle": "学習プランをアップグレード",
			"practiceTestDialogTitle": "模擬試験をアンロック",
			"restorePurchaseDialogTitle": "すでに購入済みですか？",
			"restorePurchaseDialogSubheadingWeb": "お持ちでない場合は、次をお試しください。",
			"restorePurchaseDialogBody": "この商品を購入済みなのにロックされたままの場合は、次の点をご確認ください。\n\n1. 正しいアカウントでログインしているか\n2. 正しい商品が選択されているか\n3. サブスクリプションの有効期限が切れていないか\n4. サブスクリプションを有効化したか（迷惑メールもご確認ください）\n5. アクセスコードをお持ちの場合は、[アクセスコード]({{baseUrl}}/redeem)\n\nいずれにも当てはまらない場合は、**こちらをクリック**してください",
			"restorePurchaseDialogBodyWeb": "1. 正しいメールアドレスでログインしているか\n2. 正しい**[試験が選択されている](/account/settings)**か\n3. サブスクリプションの有効期限が切れていないか\n\nいずれにも当てはまらない場合は、**サポートにお問い合わせください**",
			"accesDuration": {
				"yearPlan": "**{{duration}}**プランは延長アクセスを提供し、自分のペースで学習し、試験に包括的に準備する柔軟性を与えます。",
				"moreTime": "より多くの学習時間が必要だと思う場合は、**{{duration}}**プランを検討してください。",
				"otherPlan": "**{{duration}}**プランは**{{expiryText}}**までアクセスを許可し、学習に十分な時間を与えます。{{moreTime}}"
			},
			"actions": {
				"upgrade": "アップグレード",
				"unlock": "{{price}}でアンロック",
				"subscribe": "{{price}}で登録",
				"extendAccess": "アクセスを延長",
				"accessHere": "こちらからアクセス",
				"redeemAccessCode": "アクセスコードをお持ちですか？",
				"restorePurchase": "すでに購入済みですか？",
				"restorePurchaseWeb": "すでに購入済み、またはアクセスコードをお持ちですか？"
			},
			"subscriptionSummary": {
				"yearly": "年間サブスクリプション • 自動更新 • いつでもキャンセル可能",
				"monthly": "月額サブスクリプション • 自動更新 • いつでもキャンセル可能",
				"weekly": "週間サブスクリプション • 自動更新 • いつでもキャンセル可能",
				"generic": "自動更新サブスクリプション • いつでもキャンセル可能"
			},
			"planDuration": {
				"day_one": "{{count}}日",
				"day_other": "{{count}}日",
				"week_one": "{{count}}週間",
				"week_other": "{{count}}週間",
				"month_one": "{{count}}か月",
				"month_other": "{{count}}か月",
				"year_one": "{{count}}年",
				"year_other": "{{count}}年"
			},
			"recommendedPlan": {
				"plan": "**{{duration}}**プランで、**{{date}}**の試験に向けて万全の準備をしましょう",
				"subscription": {
					"yearly": "**年間サブスクリプション**なら継続的にアクセスでき、**{{date}}**の試験に向けて準備できます",
					"monthly": "**月額サブスクリプション**なら継続的にアクセスでき、**{{date}}**の試験に向けて準備できます",
					"weekly": "**週間サブスクリプション**なら継続的にアクセスでき、**{{date}}**の試験に向けて準備できます",
					"generic": "**サブスクリプション**なら継続的にアクセスでき、**{{date}}**の試験に向けて準備できます"
				}
			},
			"disclaimer": "購入が確定すると、選択した期間中、この製品のコンテンツにフルアクセスできます。この期間が終了すると、制限付きコンテンツへのアクセスはできなくなります。何らかの理由（試験日を変更した場合など）でアクセスを延長したい場合は、追加のアプリ内購入で期間を追加できます。詳しくは[利用規約およびプライバシーポリシー](https://memorang.com/legal)をご覧ください。"
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "{{count}}個の{{type}}にわたって解答した{{numItems}}個の{{item}}に基づく",
			"itemCount": "{{count}}個の{{item}}",
			"tooltip": "これは{{count}}個の{{type}}での進捗を示します。これまでに解答した{{itemCount}}個の{{item}}に基づいています。"
		},
		"needsImprovement": {
			"title": "改善が必要",
			"subtitle": "向上のため{{type}}を推奨",
			"cta": "学習を開始"
		},
		"mastery": {
			"high": "習得済み",
			"medium": "習得に近い",
			"low": "練習が必要",
			"count": "{{count}}個の{{item}}解答済み",
			"zeroTooltip": "解答した{{total}}個のアイテムのうち、{{label}}のアイテムはまだありません",
			"highTooltip": "回答した{{total}}個の{{item}}のうち、{{count}}個を習得しました",
			"mediumTooltip": "回答した{{total}}個の{{item}}のうち、{{count}}個が上達中です",
			"lowTooltip": "回答した{{total}}個の{{item}}のうち、{{count}}個はさらに練習が必要です"
		},
		"stats": {
			"completion": "完了率",
			"completionCount": "{{completed}}/{{total}}個の{{item}}",
			"completionTooltip": "{{total}}個の{{item}}のうち{{completed}}個を完了しました"
		},
		"exams": {
			"title": "模擬試験",
			"subtitle_one": "完了した{{count}}件の評価に基づいています",
			"subtitle_other": "完了した{{count}}件の評価に基づいています"
		},
		"summary": {
			"title": "学習概要",
			"subtitle": "{{count}}個の{{item}}を解答したに基づく",
			"tooltip": "このサマリーは{{count}}個の{{item}}での習熟度と完了進捗を示します。パフォーマンスは練習、評価、学習活動を通じて測定されます。",
			"mastery": "習熟度",
			"quickStats": "クイック統計"
		},
		"languageLearning": {
			"proficiencyCardTitle": "{{skill}}の習熟度",
			"proficiencyCardTooltip": "現在、{{skill}}は「{{level}}」レベルです",
			"itemTypesCardSubtitle_one": "問題タイプ{{count}}種類",
			"itemTypesCardSubtitle_other": "問題タイプ{{count}}種類",
			"itemTypesCardTitle": "{{skill}}の問題",
			"itemTypeLevelTooltip": "「{{itemType}}」タイプの問題では、現在{{skill}}が「{{level}}」レベルです",
			"itemTypesFallbackTitle": "問題タイプ",
			"itemTypesEmptyTitle": "問題タイプが見つかりません",
			"itemTypesEmptySubtitle": "このスキルの問題タイプが見つかりませんでした。進捗画面に戻ってもう一度お試しください。",
			"itemTypesEmptyCta": "進捗に戻る",
			"notAnswered": "未解答",
			"answeredSubtitle_one": "解答済みの{{count}}問に基づく",
			"answeredSubtitle_other": "解答済みの{{count}}問に基づく",
			"responsesSubtitle_one": "{{count}}回の解答に基づく",
			"responsesSubtitle_other": "{{count}}回の解答に基づく",
			"testsTakenSubtitle_one": "受験済みの{{count}}回のテストに基づく",
			"testsTakenSubtitle_other": "受験済みの{{count}}回のテストに基づく",
			"startFirstTest": {
				"title": "はじめましょう",
				"itemsSubtitle_one": "{{count}}問",
				"itemsSubtitle_other": "{{count}}問",
				"guidance": {
					"diagnostic": "まずは診断テストで強みを把握し、学習プランを調整しましょう。",
					"sectional": "セクション別テストは試験の一部に絞るため、短い受験時間でスコアを確認できます。",
					"fullMock": "フル模擬テストは本番と同じ流れで、最も完全なスコアが得られます。"
				}
			},
			"noScoresTitle": "{{skill}}のスコアはまだありません",
			"noScoresSubtitle": "最初のテストを受けて、推定スコアとタスクの内訳を確認しましょう。",
			"noScoresCta": "開始",
			"noScoresCardSubtitle": "受験するテストに基づく",
			"personalBestLabel": "自己ベスト",
			"latestLabel": "最新の結果",
			"examCountdown_one": "試験まであと{{count}}日",
			"examCountdown_other": "試験まであと{{count}}日",
			"greeting": {
				"none": "始めましょう、{{firstName}}さん！🚀",
				"low": "いいスタートです、{{firstName}}さん！💪",
				"medium": "その調子です、{{firstName}}さん！💪",
				"high": "あと少しです、{{firstName}}さん！🎯"
			},
			"greetingNoName": {
				"none": "始めましょう！🚀",
				"low": "いいスタートです！💪",
				"medium": "その調子です！💪",
				"high": "あと少しです！🎯"
			},
			"stats": {
				"untilExam": "試験日",
				"itemsAnswered": "解答済み問題数",
				"responsesAnswered": "解答数"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "パスコードが間違っています",
		"incorrectPassword": "パスワードが間違っています。もう一度お試しください。",
		"passwordPlaceholder": "パスワードを入力",
		"emailPlaceholder": "例：dave@gmail.com",
		"verify": {
			"openEmail": "メールを開いて続行",
			"signInCta": "アカウントを確認中...",
			"signUpCta": "アカウントを作成中...",
			"contactSupport": "メールが届きませんか？スパムフォルダを確認するか",
			"contactSupportLink": "お問い合わせ",
			"resendMagicLink": "マジックリンクを再送信",
			"resendMagicLinkIn": "{{time}}後にマジックリンクを再送信できます",
			"signInBody": "もうすぐ完了です！詳細を確認して{{appName}}アプリに安全にサインインしてください。",
			"signUpBody": "もうすぐ完了です！詳細を確認して{{appName}}アプリのアカウントを作成してください。",
			"magicLinkEmail": "**{{email}}**にマジックリンクを送信しました\nメール内のリンクをクリックして安全にサインインしてください。",
			"magicLinkEmailExpiry": "このリンクは10分後に期限切れになります",
			"confirmEmail": "メールを確認",
			"redirectingToApp": "{{appName}}アプリにリダイレクト中...",
			"appNotOpen": "アプリが開きませんか？下のボタンをクリックして関連アプリを開いてください",
			"openApp": "{{appName}}アプリを開く",
			"installAppPrompt": "何も起こらない場合は、デバイスに{{appName}}アプリがインストールされていることを確認してください",
			"verifyAccountTitle": "アカウントを確認",
			"emailResent": "メールを送信しました。スパムまたは迷惑メールフォルダを含めてメールボックスを確認してください",
			"verificationLinkExpired": "確認リンクの期限が切れました",
			"verificationLinkExpiredBody": "確認リンクは10分後に期限切れになり、一度だけ使用できます。再度サインインして新しいリンクを要求できます",
			"accountSetupTimeoutTitle": "サインインを完了できません",
			"accountSetupTimeoutBody": "アカウントの設定に予想以上の時間がかかっています。再度ログインするか、問題が続く場合はサポートにお問い合わせください。",
			"loginAgain": "再度ログイン",
			"contactSupportExpiredLink": "この問題が続く場合は、お知らせください",
			"successTitle": "別のタブでサインインしました",
			"successBody": "このタブを閉じるか、ここから続行してください",
			"successCtaLabel": "ここから続行",
			"needHelpLabel": "お困りですか？",
			"contactSupportButton": "サポートに連絡"
		},
		"contactSupportDialog": {
			"title": "ログインに問題がありますか？",
			"body": "ログインに問題がある場合はカスタマーサポートにご連絡いただくか、もう一度お試しください",
			"cta": "メールする"
		},
		"emailInstruction": {
			"default": "メールが届かない場合は、迷惑メール、スパム、最近削除されたフォルダを確認してください",
			"edu": "メールが届かない場合は、迷惑メール、スパム、最近削除されたフォルダを確認するか、IT管理者にお問い合わせください"
		},
		"createSessionLoader": {
			"configuringSession": "セッションを設定中",
			"analyzingMastery": "習熟度を分析中",
			"loadingContent": "コンテンツを読み込み中"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "何とお呼びすればよいですか？",
				"description": "あなたの名前とアバターは、ダッシュボード、レポート、ランキングに表示されます。",
				"usernameLabel": "ユーザー名",
				"firstNameLabel": "名",
				"lastNameLabel": "姓",
				"avatarLabel": "アバター",
				"avatarTooltip": "アバターはユーザー名に基づいて自動生成されます。",
				"profileSaveFailed": "プロフィールを保存できませんでした。もう一度お試しください。"
			},
			"testDate": {
				"cta": "続行"
			},
			"examDate": {
				"daysAway": "残り {{value}} 日です。すぐに最も弱い分野を重点的に対策します。"
			},
			"skills": {
				"chooseAll": "当てはまるものをすべて選択"
			},
			"plan": {
				"recommended": "おすすめ"
			},
			"toeicLevelOverview": {
				"title": "誰でも最初は初心者です。",
				"description": "練習を重ねて今のレベルで実力を固めると、自然に次のレベルへと成長していきます。",
				"illustrationLabel": "ベーシック（A1–A2）からインターミディエート（B1–B2）、プロフィシエント（C1）への成長の流れ。",
				"levels": {
					"basic": {
						"name": "ベーシック",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "インターミディエート",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "プロフィシエント",
						"band": "C1"
					}
				},
				"progression": {
					"title": "成長のステップ",
					"practiceSessions": "おすすめのセッションで練習する",
					"buildMastery": "今のレベルで実力を固める",
					"growToward": "プロフィシエントを目指して伸ばし続ける"
				},
				"levelDetails": {
					"title": "各レベルの目安",
					"scoreRange": "{{band}} · スコア {{min}}–{{max}}",
					"basic": {
						"name": "ベーシックユーザー",
						"summary": "職場で使う基本的な英語",
						"examples": {
							"forms": "書類・掲示",
							"instructions": "指示",
							"announcements": "短いアナウンス"
						}
					},
					"intermediate": {
						"name": "インターミディエートユーザー",
						"summary": "日常的な職場でのコミュニケーション",
						"examples": {
							"emails": "メール・会話",
							"customers": "顧客とのやり取り",
							"followUps": "会議後のフォローアップ"
						}
					},
					"proficient": {
						"name": "プロフィシエントユーザー",
						"summary": "専門的で高度な英語",
						"examples": {
							"reports": "複雑な報告書・プレゼンテーション",
							"negotiations": "細やかな交渉",
							"highStakes": "重要度の高いビジネスの場面"
						}
					}
				},
				"disclaimer": "TOEIC Link のスコアは CEFR に対応した目安であり、絶対的な合否基準ではありません。リーディングとリスニングは別々に伸びるため、スキルごとに到達レベルが異なる場合があります。"
			},
			"review": {
				"diagnosticChoice": {
					"title": "診断テスト：{{title}}",
					"body": "重点分野を見つけるための{{count}}問",
					"duration": "{{minutes}}分"
				},
				"homeChoice": {
					"title": "自分で探索する",
					"body": "まだ始める準備ができていないため、まずアプリを探索します"
				}
			}
		},
		"common": {
			"changeLater": "この設定はいつでも変更できます"
		},
		"actions": {
			"previous": "前へ",
			"finish": "終了",
			"start": "始める",
			"continue": "続ける",
			"stepIndicator": "ステップ {{step}}/{{total}}"
		}
	},
	"more": {
		"profile": {
			"title": "あなたについて"
		},
		"exam": {
			"title": "あなたの試験"
		},
		"subscriptions": {
			"title": "製品",
			"redeem": {
				"title": "購入を引き換える"
			},
			"extend": {
				"cta": "延長"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "目標の試験日を設定",
			"description": "この日付は、アプリ内の学習スケジュールを立てるためだけに使用されます。公式試験の受験登録には影響しません。",
			"dismissCta": "今はしない",
			"confirmCta": "試験日を設定"
		}
	},
	"account": {
		"title": "アカウント設定",
		"currentExam": "現在の試験",
		"subscriptions": "製品",
		"examDate": "試験日",
		"examDateUpdated": "試験日を{{date}}に設定しました",
		"selectDate": "日付を選択",
		"appearance": "外観",
		"features": "機能",
		"audioPlaybackTest": "テスト音声再生ダイアログを表示",
		"theme": "テーマ",
		"selectTheme": "テーマを選択",
		"themeOptions": {
			"system": "システム",
			"light": "ライト",
			"dark": "ダーク"
		},
		"accountInfo": "アカウント",
		"username": "ユーザー名",
		"name": "名前",
		"nameNotSet": "未設定",
		"save": "保存",
		"editUsername": {
			"title": "ユーザー名を編集"
		},
		"editName": {
			"title": "名前を編集"
		},
		"email": "メール",
		"dev": "開発",
		"sandbox": "サンドボックス",
		"redoOnboarding": "オンボーディングをやり直す",
		"about": "概要",
		"termsOfService": "利用規約",
		"privacyPolicy": "プライバシーポリシー",
		"aiToolsTos": "AIツール利用規約",
		"support": "サポート",
		"supportEmailBody": "以下の件でお手伝いが必要なため、お問い合わせいたします。 [  ]\n\n\n\n問題をより迅速に解決するために、以下の情報をお役立てください：\n\nアカウントに関連付けられたユーザー名（アプリにログインした状態で設定で確認できます）：\n{{username}}\n\n注文に関連付けられたメールアドレス（アプリにログインした状態で設定で確認できます）：\n{{email}}\n\n注文番号（通常、購入時に送信された領収書メールに記載されています）：\n\n商品を実際に購入した際に、異なる名前やメールアドレスが使用された可能性はありますか？もしそうであれば、それらを教えてください：\n\n姓名：\n\nメールアドレス：",
		"contactSupport": "サポートに連絡",
		"signOut": "サインアウト",
		"signOutConfirmation": "本当にサインアウトしますか？",
		"deleteAccount": "アカウントを削除",
		"platform": "プラットフォーム",
		"partnerships": "パートナーシップ",
		"validUntil": "{{date}}まで有効",
		"extendValidity": "アクセスを延長",
		"redeemPurchase": "購入を引き換える",
		"redeemPurchaseNoneFound": "引き換え可能な購入はありません",
		"redeemPurchaseCheckFailed": "購入を確認できませんでした。もう一度お試しください。",
		"purchases": "購入",
		"frequentlyAskedQuestions": "よくある質問",
		"deleteFeedbackForm": {
			"placeholder": "フィードバック"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "データ不足",
		"proficiencyLevelPendingTooltip": "レベルを推定するには、{{label}}の項目にもっと解答してください",
		"on": "で",
		"gotIt": "OK",
		"goBack": "戻る",
		"unlock": "アンロック",
		"topic": "トピック",
		"itemCount_one": "{{count, number}}個のアイテム",
		"itemCount_other": "{{count, number}}個のアイテム",
		"examCount_one": "{{count}}件の試験",
		"examCount_other": "{{count}}件の試験",
		"questionCount_one": "{{count}}問",
		"questionCount_other": "{{count}}問",
		"item_one": "アイテム",
		"item_other": "アイテム",
		"and": "と",
		"this": "この",
		"of": "の",
		"knowMore": "詳細を知る",
		"proficiency": "習熟度",
		"didNotAnswer": "まだ解答していないアイテム",
		"notAnswered": "未回答",
		"attempted": "試行済み",
		"attempt": "試行",
		"activity": "練習",
		"performance": "パフォーマンス",
		"estimatedProficiency": "推定習熟度",
		"details": "詳細",
		"keepPracticing": "練習を続けてください！良くできています！",
		"leaveFeedback": "フィードバックを残す",
		"copiedToClipboard": "クリップボードにコピーしました",
		"eg": "例",
		"set": "セット",
		"hint": "ヒント",
		"itemType": "アイテムタイプ",
		"minute": "分",
		"minutes": "分",
		"hour": "時間",
		"hours": "時間",
		"continue": "続行",
		"cancel": "キャンセル",
		"view": "表示",
		"switch": "切り替え",
		"update": "更新",
		"ok": "OK",
		"yes": "はい",
		"free": "無料",
		"answered": "回答済み",
		"correct": "正解",
		"incorrect": "不正解",
		"marked": "マークされた",
		"unmarked": "未マーク",
		"skipped": "スキップされた",
		"skill_one": "スキル",
		"skill_other": "スキル",
		"word_one": "語",
		"word_other": "語",
		"submitResponse": "回答を提出",
		"viewDetails": "詳細を表示",
		"sec_one": "秒",
		"sec_other": "秒",
		"point_one": "ポイント",
		"point_other": "ポイント",
		"week": "週",
		"month": "月",
		"year": "年",
		"day": "日",
		"selectTestDate": "試験日を選択",
		"points": "ポイント",
		"viewAll": "すべて表示",
		"timeline": "タイムライン",
		"save": "保存",
		"filters": {
			"selectAll": "すべて選択",
			"deselectAll": "すべて選択解除",
			"selectedCount": "{{count}}件選択中",
			"expandSection": "{{section}}を展開",
			"collapseSection": "{{section}}を折りたたむ"
		},
		"showMore": "もっと見る",
		"showLess": "表示を減らす",
		"expandA11yLabel": "説明を展開",
		"collapseA11yLabel": "説明を折りたたむ",
		"done": "完了",
		"clearAll": "すべてクリア",
		"clear": "クリア",
		"datePicker": {
			"title": "日付を選択",
			"enterDateLabel": "日付を入力",
			"enterDateRangeLabel": "期間を入力",
			"dateLabel": "日付",
			"startDateLabel": "開始日",
			"endDateLabel": "終了日",
			"dateRequiredError": "日付は必須です",
			"invalidDateFormatError": "日付の形式が正しくありません。MM/DD/YYYY形式で入力してください",
			"startAfterEndError": "開始日は終了日より後にできません",
			"endBeforeStartError": "終了日は開始日より前にできません",
			"minDateError": "{{date}}以降の日付を入力してください",
			"maxDateError": "{{date}}以前の日付を入力してください",
			"dateRangeError": "{{startDate}}から{{endDate}}までの日付を入力してください",
			"setDateCta": "日付を設定",
			"nextCta": "次へ",
			"setTimeCta": "時刻を設定"
		}
	},
	"session": {
		"choicePercentageTooltip": "{{percentage}}の学習者がこの選択肢を選びました。",
		"choiceCorrectA11yLabel": "正解",
		"choiceIncorrectA11yLabel": "不正解",
		"choiceNotSelectedA11yLabel": "未選択",
		"moreItemsAlertDialog": {
			"title": "追加アイテム",
			"cta": "了解"
		},
		"results": {
			"followUps": {
				"title": "フォローアップ"
			},
			"summary": {
				"sessionAnalysis": "セッション分析",
				"itemCount_one": "{{count}}問",
				"itemCount_other": "{{count}}問",
				"skilledItemCount_one": "{{skills}}の問題を{{count}}問",
				"skilledItemCount_other": "{{skills}}の問題を{{count}}問",
				"levelPhrase_one": "{{levels}}レベルの",
				"levelPhrase_other": "{{levels}}レベルの",
				"message": "<bold>よくできました！</bold>{{timeTaken}}で{{itemPhrase}}完了しました。",
				"messageWithLevels": "<bold>よくできました！</bold>{{timeTaken}}で$t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}){{itemPhrase}}完了しました。",
				"proficiencyEstimateReady": "推定の{{skill}}レベルは<bold>{{currentLevel}}</bold>です。<bold>{{nextLevel}}</bold>を目標に取り組む準備ができました。",
				"proficiencyEstimateKeepPracticing": "推定の{{skill}}レベルは<bold>{{currentLevel}}</bold>です。<bold>{{nextLevel}}</bold>に進む前に、練習を続けましょう。",
				"proficiencyEstimateHighest": "推定の{{skill}}レベルは<bold>{{currentLevel}}</bold>です。素晴らしい成果です！",
				"mixedLevel": "ミックス",
				"overallScore": "総合スコア",
				"stats": {
					"itemsAttempted_one": "解答した問題",
					"itemsAttempted_other": "解答した問題",
					"pointsEarned_one": "獲得ポイント",
					"pointsEarned_other": "獲得ポイント",
					"answeredCorrectly": "正解した問題",
					"timeTaken": "所要時間",
					"target": "目標",
					"ofTotal": "/ {{total}}",
					"ofPointsTotal": "/ {{total}}",
					"skill": "スキル",
					"skills": "スキル",
					"questionType": "問題タイプ",
					"questionTypes": "問題タイプ",
					"proficiencyLevel": "習熟度レベル",
					"proficiencyLevels": "習熟度レベル"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "音声は{{seconds}}秒後に開始します",
			"audioStartsInPlayOnce": "音声は{{seconds}}秒後に開始します、一度のみ再生されます",
			"videoStartsIn": "動画は{{seconds}}秒後に開始します",
			"videoStartsInPlayOnce": "動画は{{seconds}}秒後に開始します、一度のみ再生されます",
			"recordingIn": "{{seconds}}秒後に録音開始"
		},
		"timeOverrunBanner": {
			"message": "時間切れです。本番の試験では、この後の回答は採点されません。引き続き練習できます。"
		},
		"attributes": {
			"stimulus": "刺激"
		},
		"stimulusTypes": {
			"reading": "リーディング",
			"listening": "リスニング",
			"speaking": "スピーキング",
			"writing": "ライティング",
			"image": "画像"
		},
		"masteryLevels": {
			"belowBasic": "基礎未満",
			"basic": "基礎",
			"belowLowIntermediate": "初中級未満",
			"lowIntermediate": "初中級",
			"highIntermediate": "上中級",
			"advanced": "上級",
			"proficiencySubtitle": "{{trademark}}では、これは**{{minScore}}-{{maxScore}}/30**のスコアに対応します",
			"infoSectionLabel": "{{skill}}セクション情報",
			"infoSectionText": {
				"Reading": "{{trademark}}リーディングセクションは、学術的資料を読み理解する能力を評価します。約700語の2つのリーディング資料が含まれ、それぞれに10問があります。リーディングセクションの完了には約35分かかります。",
				"Listening": "{{trademark}}リスニングセクションは、話し言葉と講義を理解する能力を測定するように設計されています。基本的な理解、話者の態度と確信の理解、情報の接続を含むリスニング材料が含まれます。リスニングセクションの完了には約36分かかります。",
				"Speaking": "{{trademark}}スピーキングセクションは、学術的環境で英語を効果的に使用する能力を測定します。4つの質問/タスクは、学校内外で遭遇する可能性のある現実的な状況に似ています。スピーキングセクションの完了には約16分かかります。",
				"Writing": "{{trademark}}ライティングセクションは、学術的環境で英語を使用する能力を測定します。コンピューターで回答を入力し、ライティングセクションの完了には約29分かかります。"
			}
		},
		"itemTypes": {
			"MCSS": "単一選択問題",
			"MCSSH": "単一選択ハイライト問題",
			"MCMS": "複数選択問題",
			"MCMSH": "複数選択ハイライト問題",
			"INSERT_TEXT": "テキスト挿入問題",
			"MATCH_MS": "複数項目マッチング問題",
			"MCSSM": "単一選択マッチング問題",
			"MCMSM": "複数選択マッチング問題",
			"MCGS": "空欄選択問題",
			"MCOS": "順序選択問題",
			"LISTENING_REPLAY": "リスニング再生問題",
			"AUDIO_INPUT": "音声入力問題",
			"ACADEMIC_DISCUSSION_RESPONSE": "学術討論回答問題",
			"INTEGRATED_WRITING_RESPONSE": "統合ライティング回答問題"
		},
		"passageStem": {
			"itemOfTotal": "アイテム {{current}}/{{total}}",
			"questionOfTotal": "質問 {{current}}/{{total}}",
			"stimulusCorrespondsToNextItems": "次の{{total}}問に対応する設問文です",
			"passage": "パッセージ",
			"lecture": "講義",
			"professorsQuestion": "教授の質問",
			"listen": "聞く",
			"openPassage": "パッセージを開く",
			"backToItem": "問題に戻る",
			"notYetInserted": "まだ挿入されていません",
			"insertedAtPosition": "位置 #{{position}} に挿入されました"
		},
		"hint": {
			"show": "ヒントを表示"
		},
		"navigation": {
			"next": "次へ",
			"exit": "終了",
			"saveAndExit": "保存して終了",
			"previous": "前へ",
			"skip": "スキップ",
			"finish": "完了",
			"help": "ヘルプ",
			"about": "問題のヒント",
			"questionsButtonLabel": "問題ナビゲーション",
			"questionsButtonTooltip": "問題にジャンプして回答、スキップ、マークされたアイテムを一目で確認します。",
			"questionsButtonActiveFiltersA11y": "有効なフィルター: {{count}} 件",
			"recordingInProgressTooltip": "録音中はこの問題から移動できません",
			"questionNotReachedTooltip": "この問題にはまだ到達していません"
		},
		"questionTips": {
			"hideFutureLabel": "ヒントを自動で表示しない"
		},
		"toolbar": {
			"calculatorTooltip": "電卓を開く",
			"highlightTooltip": "テキストを選択して重要な情報をハイライトし、後で参照しやすくします",
			"markTooltip": "この問題にフラグを付けて、提出前に見直します",
			"unmarkTooltip": "クリックしてこの問題のマークを解除します"
		},
		"summary": {
			"viewFullInsights": "詳細なインサイトを表示",
			"targetTooltip": "このセッションのパフォーマンス目標です。"
		},
		"stats": {
			"skill": "スキル",
			"answered": "回答済み",
			"speed": "速度",
			"duration": "録音時間",
			"duration_tooltip": "録音した回答の長さ: {{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "信頼度",
			"pointsEarned": "ポイント",
			"word": "語",
			"words": "語数",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "この問題を読んで答えるのに {{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) かかりました",
			"skill_tooltip": "この問題で評価されるスキル領域: {{skill}}",
			"answered_correct_tooltip": "提出した回答は正解でした",
			"answered_incorrect_tooltip": "提出した回答は不正解でした",
			"skipped_tooltip": "この問題に回答を提出していません",
			"words_tooltip": "記述回答の語数: {{count}}",
			"word_tooltip": "記述回答の語数: {{count}}",
			"confidence_tooltip": "回答提出時に選択した自信の程度です",
			"points_earned_tooltip_one": "この問題で満点 {{maximumScore}} ポイント中 {{points}} ポイントを獲得しました",
			"points_earned_tooltip_other": "この問題で満点 {{maximumScore}} ポイント中 {{points}} ポイントを獲得しました",
			"challengers_tooltip": "あなたより先にこの問題に解答した学習者数: {{count}}",
			"learning_mode_points_tooltip": "この試行で獲得したポイント: +{{xp}} XP",
			"pts_earned_tooltip": "この試行で獲得したポイント: {{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "内訳を展開"
		},
		"explanation": {
			"title": "解説",
			"feedback": "フィードバック",
			"skippedFeedbackNotice": "この問題をスキップしたため、パーソナライズされたフィードバックは生成されませんでした。"
		},
		"followUps": "フォローアップ質問",
		"suggestCorrection": "修正を提案",
		"answer": {
			"correct": "正解",
			"incorrect": "不正解",
			"skipped": "スキップ"
		},
		"confidence": {
			"high": "高",
			"medium": "中",
			"low": "低"
		},
		"endDialog": {
			"title": "学習セッションを終了",
			"confirmEndDiagnostic": "本当にこのセッションを終了しますか？すべての進捗が失われ、再開する必要があります。",
			"confirmEnd": "まだ {{num}} {{itemLabel}} が残っています。今すぐ終了するか、続けてそれらを完了します。",
			"confirmEndNoAnswer": "まだ問題に答えていません。今すぐ終了しますか？",
			"confirmEndNoAnswerPositive": "学習を続ける",
			"confirmEndNoAnswerNegative": "今すぐ終了"
		},
		"permissionDialog": {
			"title": "マイクへのアクセスが必要です",
			"descriptionWeb": "スピーキング練習にはマイクを使用します。ブラウザがこのサイトのマイクをブロックしています。アドレスバーの横にある権限アイコンをクリックしてマイクを許可し、もう一度お試しください。",
			"descriptionMobile": "スピーキング練習にはマイクを使用します。続行するには、デバイスの設定でマイクへのアクセスを許可してください。",
			"promptDescriptionWeb": "スピーキング練習にはマイクを使用します。権限をリクエストし、ブラウザに表示されたら「許可」を選択してください。",
			"blockedDescriptionWeb": "このサイトのマイクへのアクセスがブロックされています。アドレスバーの横にあるアイコンをクリックしてマイクを許可し、もう一度権限をリクエストしてください。",
			"ok": "OK",
			"cancel": "キャンセル",
			"openSettings": "設定を開く",
			"requestPermission": "権限をリクエスト",
			"dismissAndExit": "閉じて終了",
			"learnMore": "詳細"
		},
		"audioPlaybackTestDialog": {
			"title": "音声再生をテスト",
			"description": "{{appName}} には刺激、テスト項目、テキスト読み上げなど、複数の音声再生機能が含まれています。最適な体験を確保するため、音声をテストしてください。正常に動作することを確認したら、続行してください。",
			"troubleshooting": {
				"title": "音声問題のトラブルシューティング",
				"volumeTitle": "デバイスの音量を確認",
				"volumeDescriptionWeb": "キーボードコントロールまたはメニュー/タスクバーのシステム音量設定で音量を調整",
				"volumeDescriptionMobile": "デバイスの音量ボタンまたはシステム設定で調整",
				"outputTitle": "音声出力デバイスを確認",
				"outputDescription": "ヘッドフォンを使用している場合は、正しく接続され、アクティブな出力デバイスとして選択されていることを確認",
				"browserTitle": "ブラウザタブの音声を確認",
				"browserDescription": "タブタイトルの横にミュートスピーカーアイコンがあるかどうかを確認し、ある場合はミュートを解除"
			},
			"skipCheck": "次回この確認をスキップ",
			"workingButton": "音声が正常であることを確認",
			"textToHear": "聞こえるはずの音声：{{text}}"
		},
		"overall": "全体",
		"subskills": {
			"content": {
				"title": "内容"
			},
			"languageUse": {
				"title": "言語使用"
			},
			"organizationAndDevelopment": {
				"title": "構成と発展"
			},
			"topicDevelopment": {
				"title": "トピック発展"
			},
			"delivery": {
				"title": "話し方"
			}
		},
		"finalizing": {
			"title": "結果を確定しています",
			"gradingProgress": "回答を採点中..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "聞き取った文をできるだけ正確に繰り返すスピーキング課題です。",
			"Read Aloud": "文章を音読して評価を受けるスピーキング問題です。",
			"Describe Image": "画像などの視覚素材を詳しく説明するスピーキング課題です。",
			"Write Essay": "与えられたテーマについて構成の整ったエッセイを書く記述式課題です。",
			"Retell Lecture": "聞いた講義やトークの内容を要約して話すスピーキング課題です。",
			"Summarize Group Discussion": "複数の話者によるディスカッションを要約するリスニング課題です。",
			"Answer Short Question": "短い質問1つに簡潔に答える短いスピーキング課題です。",
			"Respond to a Situation": "提示された状況に適切に応答するスピーキング課題です。",
			"Summarize Written Text": "文章を自分の言葉で要約するリーディング課題です。",
			"Reorder Paragraph": "バラバラになった段落を正しい順序に並べ替えるリーディング課題です。",
			"Fill in the Blanks (Dropdown)": "各空欄をドロップダウンの選択肢から選んで埋めるリーディング課題です。",
			"Fill in the Blanks (Type In)": "欠けている単語や短いフレーズを入力するリスニング課題です。",
			"Fill in the Blanks (Drag and Drop)": "選択肢を空欄にドラッグして欠けている単語を埋めるリーディング課題です。",
			"Multiple Choice, Single Answer": "正しい答えを1つ選ぶ多肢選択問題です。",
			"Multiple Choice, Single Answer (Reading)": "正しい答えを1つ選ぶリーディングの多肢選択問題です。",
			"Multiple Choice, Single Answer (Listening)": "正しい答えを1つ選ぶリスニングの多肢選択問題です。",
			"Multiple Choice, Multiple Answers": "正しい答えを複数選べる問題です。",
			"Multiple Choice, Multiple Answers (Reading)": "正しい答えを複数選べるリーディング問題です。",
			"Multiple Choice, Multiple Answers (Listening)": "正しい答えを複数選べるリスニング問題です。",
			"Summarize Spoken Text": "聞いた内容の要約を書くリスニング課題です。",
			"Highlight Correct Summary": "音声の内容に最も合う要約を選んでハイライトするリスニング課題です。",
			"Select Missing Word": "欠けている単語を選ぶ穴埋め形式のリスニング課題です。",
			"Highlight Incorrect Words": "音声と異なるトランスクリプト内の単語をハイライトするリスニング課題です。",
			"Write from Dictation": "聞き取った文を書き取るリスニング課題です。"
		}
	},
	"report": {
		"readFullInsights": "インサイト全文を読む",
		"productName": "{{examName}} {{type}}",
		"startedAt": "開始時刻: {{time}}",
		"itemTypesTitle": "問題タイプの内訳",
		"itemTypesFilterAll": "すべて",
		"questionTypeCardTitle": "{{skill}}の問題タイプの内訳",
		"questionTypeCardSubtitle_one": "このセッションの{{count}}種類の{{skill}}問題タイプに基づく",
		"questionTypeCardSubtitle_other": "このセッションの{{count}}種類の{{skill}}問題タイプに基づく",
		"questionTypeCardAltSubtitle_one": "このセッションの{{count}}種類の問題タイプに基づく",
		"questionTypeCardAltSubtitle_other": "このセッションの{{count}}種類の問題タイプに基づく",
		"questionTypeRowSubtitle_zero": "回答した問題はありません",
		"questionTypeRowSubtitle_one": "{{count}}問回答済み",
		"questionTypeRowSubtitle_other": "{{count}}問回答済み",
		"itemTypeDetail": {
			"review_one": "問題を確認",
			"review_other": "問題を確認",
			"stats": {
				"answered_one": "解答した問題",
				"answered_other": "解答した問題",
				"avgTime": "1問あたりの平均時間"
			}
		},
		"reviewAnswersDialog": {
			"title": "回答を確認",
			"sections": {
				"skills": "スキル",
				"questionTypes": "問題タイプ",
				"proficiency": "習熟度",
				"performance": "パフォーマンス"
			},
			"summaryNone": "続行するには、項目のあるフィルターを選択してください。",
			"summaryAll_one": "すべての{{count}}件の回答を確認します。",
			"summaryAll_other": "すべての{{count}}件の回答を確認します。",
			"summaryFiltered_one": "{{filters}}に一致する{{count}}件の回答を確認します。",
			"summaryFiltered_other": "{{filters}}に一致する{{count}}件の回答を確認します。",
			"reviewAnswers_one": "{{count}}件の回答を確認",
			"reviewAnswers_other": "{{count}}件の回答を確認",
			"more": "ほか{{count}}件"
		},
		"itemDetail": {
			"title": "回答を確認",
			"filterAll": "すべて",
			"filterCorrect": "正解",
			"filterIncorrect": "不正解",
			"filterMarked": "マーク済み",
			"emptyTitle": "一致する問題がありません",
			"emptyDescription": "セッションの問題のうち、選択したフィルタ（{{filter}}）に一致するものがありません。フィルタを調整するか、クリアしてより多くの結果を表示してください。",
			"emptyCta": "フィルタをクリア"
		},
		"answerCardTitle": "回答済みの問題",
		"answerCardSubtitle_one": "すべての問題での成績を確認",
		"answerCardSubtitle_other": "全{{count}}問での成績を確認",
		"skillsBreakdown": {
			"title": "スキル別スコア",
			"subtitle_one": "{{count}} 問の問題に基づく",
			"subtitle_other": "{{count}} 問の問題に基づく"
		},
		"studyPack": "スタディパック",
		"practiceTestCompleted": "模擬試験完了",
		"studySessionCompleted": "学習セッション完了",
		"diagnosticSessionCompleted": "診断評価セッション完了",
		"timeElapsed": "経過時間",
		"stats": {
			"answered": "回答済み",
			"time elapsed": "経過時間",
			"avg speed": "平均速度",
			"hints used": "使用したヒント"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "優秀なパフォーマンス——卓越性を追求し続けてください！",
				"highIntermediate": "とても良くできています——強みを磨き続けてください！",
				"lowIntermediate": "着実に進歩しています——継続してください！",
				"basic": "能力向上に向けて努力を続けてください！"
			},
			"infoText": "あなたは **{{numActivities}} {{activityLabel}}** を完了して、{{skillsText}} {{skills}} を練習しました. {{skillDetails}}. 全体的に、**{{numPointsEarned}} ポイント**を獲得し、{{thisText}} {{skills}} で **{{compositeLevel}} レベル** を示しました。{{compositeFeedback}}",
			"infoText.singleSkill": "あなたは **{{itemCount}} {{itemLabel}}** を完了し、**{{skill_1}}** スキルに焦点を当てました。**{{skill_1_score}} ポイント（総計 {{skill_1_total}} ポイント）**を獲得し、**{{proficiency}}** レベルに達しました。{{compositeFeedback}}",
			"infoText.multiSkill": "あなたは **{{itemCount}} {{itemLabel}}** を完了し、**{{skills_text}}** スキルを練習しました。{{skill_details}} 全体的に、**{{overall_score}} ポイント（総計 {{overall_total}} ポイント）**を獲得し、これらのスキルで **{{overall_proficiency}}** レベルに達しました。{{compositeFeedback}}",
			"skillDetails": "**{{skill}}** で、**{{score}} ポイント（総計 {{total}} ポイント）**を獲得し、**{{proficiency}}** レベルを示しました。"
		},
		"actions": {
			"goToHome": "ホームページに戻る",
			"studyMore": "続けて学習",
			"studyFree": "無料で{{tagTypes}}を学習",
			"reviewAnswers": "回答を復習"
		},
		"nextAction": {
			"title": "おすすめ: {{focus}}の練習",
			"dialog": {
				"title": "おすすめの学習セッション",
				"subtitle": "苦手な分野に集中しましょう"
			},
			"fallback": {
				"title": "練習を続けましょう",
				"description": "次に取り組みたい分野に合わせて学習セッションを作成しましょう。"
			}
		},
		"premium": {
			"upgradeCta": "プレミアムにアップグレード"
		},
		"disclaimer": {
			"title": "免責事項",
			"summativeBody": "模擬試験のスコアは目安であり、本番の {{examName}} 試験で同じ結果になることを保証するものではありません。"
		},
		"performance": {
			"title": "パフォーマンス",
			"subtitle": "{{count}} 個のアイテムに基づく",
			"correct": "正解",
			"correctItems": "{{count}} 個",
			"incorrect": "不正解",
			"incorrectItems": "{{count}} 個のアイテム"
		},
		"mastery": {
			"performanceTitle": "パフォーマンス",
			"sessionMasteryTitle": "推定習熟度",
			"subtitle_assessment": "この評価の全{{count}}件の{{item}}に基づいています",
			"subtitle_session": "このセッションの全{{count}}件の{{item}}に基づいています"
		},
		"sessionAnalysis": {
			"title": "セッション分析",
			"subtitle": "個人化された分析と推奨事項",
			"viewFullAnalysis": "完全な分析を表示",
			"feedbackDialog": {
				"body": "私たちはほぼ毎日改善しており、改善に決意を持っています。**フィードバック**をお聞かせいただけませんか？",
				"placeholder": "フィードバックを入力",
				"cta": "フィードバックを送信",
				"successMessage": "フィードバックをありがとうございます！",
				"feedbackLimitError": "フィードバックは最低10文字必要です"
			},
			"menuActions": {
				"copy": "コピー",
				"altCopy": "サマリーテキストをコピー",
				"altPositiveFeedback": "これは役立ちます",
				"positiveFeedback": "良い回答",
				"negativeFeedback": "良くない回答",
				"reportIssue": "報告",
				"altReportIssue": "この回答を報告",
				"emailSummary": "サマリーを送信",
				"emailAlreadySent": "送信済み",
				"copiedAnalysis": "分析をクリップボードにコピーしました",
				"emailSent": "{{email}} に送信しました。メールが届かない場合は、スパム、迷惑メール、最近削除されたフォルダを確認するか、IT管理者にお問い合わせください",
				"emailFailed": "{{email}} への送信に失敗しました",
				"emailInstructionMessage": "メールが届かない場合は、スパム、迷惑メール、最近削除されたフォルダを確認するか、IT管理者にお問い合わせください"
			}
		}
	},
	"feedback": {
		"successMessage": "フィードバックをありがとうございます！"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "何が気に入りましたか？改善できることはありますか？私たちは毎日プラットフォームを改善しており、チームはすべてのフィードバックを読んでいます。ありがとうございます！",
			"title": "フィードバックをお聞かせください",
			"body": "何が気に入りましたか？改善できることはありますか？私たちは毎日プラットフォームを改善しており、チームはすべてのフィードバックを読んでいます。**ありがとうございます！**",
			"positiveBody": "お役に立てて嬉しいです！**良かった点**をお聞かせください。",
			"negativeBody": "何がうまくいかなかったかを教えていただければ、**回答の改善**に役立てます。",
			"placeholder": "フィードバックを入力",
			"cta": "フィードバックを送信"
		},
		"report": {
			"title": "レポートを送信",
			"body": "この回答の問題点を理解するのにご協力ください",
			"cta": "レポートを送信"
		},
		"suggestCorrection": {
			"title": "修正を提案",
			"body": "このコンテンツの正確性向上にご協力ください。**誤りを報告**してください。",
			"cta": "送信"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "不正確",
					"description": "回答に誤った情報が含まれています"
				},
				"notHelpful": {
					"title": "役に立たない",
					"description": "回答が質問に対応していません"
				},
				"incomplete": {
					"title": "不完全",
					"description": "回答に重要な詳細が欠けています"
				},
				"hardToUnderstand": {
					"title": "理解しにくい",
					"description": "回答がわかりにくい、または不明確です"
				},
				"other": {
					"title": "その他",
					"description": "その他の理由"
				}
			},
			"report": {
				"misinformation": {
					"title": "誤情報",
					"description": "回答に虚偽または誤解を招く情報が含まれています"
				},
				"harmfulContent": {
					"title": "有害または不適切なコンテンツ",
					"description": "ヘイトスピーチ、ハラスメント、または不適切な言葉遣い"
				},
				"violatesPolicies": {
					"title": "ポリシー違反",
					"description": "スパム、自己宣伝、または違法なコンテンツ"
				},
				"other": {
					"title": "その他",
					"description": "問題点をご自身の言葉でお書きください"
				}
			}
		},
		"faqs": {
			"title": "よくある質問",
			"body": "アプリに関するよくある質問です。他にご質問がございましたら、お気軽にお問い合わせください support@memorang.ai"
		},
		"delete": {
			"title": "アカウントを削除",
			"body": "退会されるのは残念ですが、学業とキャリアの道のりでの成功をお祈りしています！",
			"options": "高すぎる|すでに試験を受けた|コンテンツが気に入らない|機能/機能性の不足|その他",
			"confirmdelete": {
				"title": "アカウント削除を確認",
				"cta": "削除",
				"errorMessage": "申し訳ありませんが、そのメールはこのアカウントと一致しません。もう一度お試しください",
				"successMessage": "アカウントの削除が成功しました！",
				"validEmail": "有効なメールアドレスを入力してください"
			}
		}
	},
	"recorder": {
		"tapToRecord": "ボタンをタップして録音を開始",
		"responseAudioUnavailable": "回答音声は再生できません",
		"recording": "録音中",
		"recordingCompleted": "録音完了",
		"getReady": "準備してください",
		"timeIsUp": "時間切れです。回答は録音されませんでした。",
		"alert": {
			"title": "最大時間に到達しました",
			"body": "録音は最大時間{{maxDuration}}秒に達したため停止されました。"
		},
		"uiElementPressed": "録音停止 - 録音中に刺激が開かれました。"
	},
	"writing": {
		"placeholder": "ここに回答を書いてください...",
		"wordCount": "{{count}} {{word}}",
		"title": "あなたの回答",
		"submit": "提出",
		"helper": {
			"range": "回答を提出するには{{min}}〜{{max}}語で書いてください",
			"min": "回答を提出するには{{min}}語以上書いてください",
			"max": "回答を{{max}}語以内に短くしてください"
		}
	},
	"navbar": {
		"home": "ホーム",
		"progress": "進捗",
		"insights": "インサイト",
		"leaderboard": "リーダー",
		"store": "ストア",
		"more": "その他",
		"redeem": "還元",
		"study-pack": "スタディパック",
		"podcasts": "ポッドキャスト",
		"modules": "モジュール",
		"account": "アカウント設定",
		"accountTab": "アカウント",
		"privacy": "プライバシー",
		"terms": "利用規約",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "コードは正しく入力したのに問題が解決しませんか？**サポートに連絡**し、アクセスコードと購入詳細を必ずお伝えください",
		"olxDialog": {
			"unlockedTitle": "アクセスが解除されました",
			"expiredTitle": "アクセスの有効期限が切れました",
			"testInfo": "**試験:** {{examName}} | **テスト:** {{bundleName}}",
			"upcomingBody_one": "OLXテストへのアクセスが解除されました！\n\n**{{count}} 日後**にセッションを開始できます。後ほど模擬テストタブからセッションを開始してください。",
			"upcomingBody_other": "OLXテストへのアクセスが解除されました！\n\n**{{count}} 日後**にセッションを開始できます。後ほど模擬テストタブからセッションを開始してください。",
			"activeBody": "OLXテストへのアクセスが有効になりました！\n\n**{{date}}** までいつでもセッションを開始できます。\n\n今すぐセッションを開始しますか、それとも後で開始しますか？",
			"expiredBody": "OLXテストへのアクセスは **{{date}}** に期限切れになりました。\n\n詳しくは担当の教員または学校の管理者にお問い合わせください。",
			"startNowCta": "今すぐ開始",
			"startLaterCta": "後で開始"
		},
		"unexpectedError": "予期しないエラーが発生しました。"
	},
	"redeemCode": {
		"titleRedeem": "アクセスを引き換える",
		"titleGranted": "アクセスが付与されました",
		"formTitle": "アクセスコードを入力してください",
		"accessCodeHint": "アクセスコードをお持ちの場合は、ダッシュを含めてここに入力してください。",
		"submit": "引き換える",
		"access": "ここからアクセス",
		"helpFindCode": "コードの見つけ方についてサポートが必要ですか？",
		"troubleRedeeming": "コードの引き換えに問題がありますか？アシスタントに聞く！",
		"skipStep": "このステップをスキップ"
	},
	"autoRedeem": {
		"redeem": "引き換える",
		"redeeming": "引き換え中...",
		"continue": "続行",
		"unredeemedPrompt_one": "メールアドレス **{{email}}** に関連付けられた未引き換えの **{{count}} 件の製品** があります。アカウントに追加しますか？",
		"unredeemedPrompt_other": "メールアドレス **{{email}}** に関連付けられた未引き換えの **{{count}} 件の製品** があります。アカウントに追加しますか？",
		"successMessage_one": "おめでとうございます！以下の**製品**がアカウントでロック解除されました。続行を押すと、アプリのコンテキストが試験 **{{examName}}** に変更されます。別の試験の学習や別の製品の購入を希望する場合は、アカウント設定からいつでも変更できます。",
		"successMessage_other": "おめでとうございます！以下の **{{count}} 製品** がアカウントでロック解除されました。続行を押すと、アプリのコンテキストが試験 **{{examName}}** に変更されます。別の試験の学習や別の製品の購入を希望する場合は、アカウント設定からいつでも変更できます。"
	},
	"olxEligibility": {
		"goToPracticeTests": "模擬テストへ"
	},
	"moreChallenges": {
		"challenges": "チャレンジ",
		"challengesCount": "{{value}} チャレンジ"
	},
	"tts": {
		"tooltip": "このテキストを聞く"
	},
	"commandBar": {
		"placeholder": "検索...",
		"input": {
			"placeholder": "コマンドを入力するか検索"
		},
		"sections": {
			"quickActions": "クイックアクション"
		},
		"actions": {
			"changeExam": "試験を変更",
			"switchToDarkMode": "ダークモードに切り替える",
			"switchToLightMode": "ライトモードに切り替える",
			"setExamDate": "試験日を設定"
		}
	},
	"filterView": {
		"placeholder": "試験を検索..."
	},
	"transcript": {
		"show": "トランスクリプトを表示",
		"hide": "トランスクリプトを非表示"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "アプリロゴ",
			"testNameLabel": "テスト名",
			"sectionLabel": "セクション",
			"back": "戻る",
			"pause": "一時停止",
			"menuLabel": "その他のオプション"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "テスト進捗",
			"of": "/",
			"pauseSession": "セッションを一時停止",
			"timerTooltip": {
				"item": "この問題の残り時間",
				"section": "このセクションの残り時間",
				"test": "このテストの残り時間"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "次へ"
		},
		"progressBar": {
			"timeLeftLabel": "この問題の残り時間",
			"timeLeftForUnit": "このユニットの残り時間",
			"questionOf": "問題 {{current}}/{{total}}",
			"questionProgress": "<b>{{current}}</b>/{{total}}",
			"timesUp": "時間切れ",
			"statusTooltips": {
				"answered": "回答済み",
				"inProgress": "回答中",
				"skipped": "スキップ",
				"notSeen": "未表示"
			}
		},
		"timeRemainingDialog": {
			"title": "まだ時間があります",
			"body": "このユニットにはまだ時間が残っています。提出前に回答を見直しますか？",
			"reviewCta": "回答を見直す"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "ソース",
				"answerTitle": "あなたの解答",
				"remainingBadge": "残り {{count}}",
				"placedBadge": "{{count}} 件配置済み",
				"pointsBadge": "{{earned}}/{{max}} 点",
				"emptyHint": "左のパネルから段落をここにドラッグしてください"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "サポート情報",
			"emailLabel": "メール",
			"subjectLabel": "件名",
			"messageBodyLabel": "メッセージ本文",
			"appDetailsLabel": "アプリ詳細",
			"appNameLabel": "名前",
			"versionLabel": "バージョン",
			"platformLabel": "プラットフォーム"
		},
		"chat": {
			"assistantTitle": "{{tenantName}} サポートアシスタント",
			"fallbackTitle": "チャット",
			"betaWarning": "このAIアシスタントは**ベータ版**です—回答が不正確または不完全な場合があります。",
			"greeting": "こんにちは 👋 製品へのアクセスにお困りですか？お手伝いします！まず、問題を絞り込みましょう。以下のうち、あなたの状況に最も近いものはどれですか？\n\n1. アクセスコードはあるが、うまく機能しないようだ。\n2. 購入したが、アクセスコードが見つからない。\n3. 学校を通じてアクセスが付与されているはずだが、アクセスコードが見つからない。\n4. 以前は製品にアクセスできていたが、現在はアクセスできない。\n\n問題に該当する番号を入力してください。",
			"input": {
				"label": "メッセージを入力...",
				"sendLabel": "送信"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 引き換えが完了しました",
			"previouslyRedeemedTitle": "🚀 以前に引き換え済みです",
			"subtitle": "こちらからコンテンツにアクセスできます",
			"expires": "有効期限: {{date}}",
			"openCta": "開く"
		},
		"purchases": {
			"title": "🎉 アクセスコードが見つかりました",
			"subtitle": "引き換えてコンテンツにアクセスしましょう",
			"accessCodesLabel_one": "アクセスコード",
			"accessCodesLabel_other": "アクセスコード",
			"moreCodes_one": "（他 {{count}} 件）",
			"moreCodes_other": "（他 {{count}} 件）",
			"featuresLabel": "特典",
			"redeemCta": "引き換える"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "新しいバージョンが利用可能です。更新をクリックしてください。",
			"refreshCta": "更新",
			"refreshA11yLabel": "更新してアプリを最新の状態にする",
			"dismissTooltip": "閉じる",
			"dismissA11yLabel": "更新通知を閉じる"
		}
	},
	"cme": {
		"type": "CME タイプ",
		"chooseExportMethod": "エクスポート方法を選択",
		"selectDateRange": "日付範囲を選択",
		"from": "開始日",
		"to": "終了日",
		"sendPdfTo": "PDFを{{email}}に送信",
		"downloadCertificate": "証明書をPDFダウンロード",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "獲得した CME クレジット",
		"confirmYourName": "お名前をご確認ください",
		"certificateNameNotice": "このお名前は CME 修了証に印刷されます。",
		"firstName": "名",
		"lastName": "姓",
		"firstNamePlaceholder": "お名前を入力してください",
		"lastNamePlaceholder": "お姓を入力してください",
		"confirm": "確認",
		"creditsEarnedTitle": "獲得した CME",
		"creditRatioCaption": "12 チャレンジ = 1 CME クレジット",
		"earned": "獲得",
		"available": "利用可能",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "CME 修了証をエクスポート",
		"exportDisabledCaption": "修了証をエクスポートするには、少なくとも 1 CME クレジットを獲得する必要があります",
		"viewDisclaimer": "CME 免責事項を表示"
	},
	"podcast": {
		"detail": {
			"descriptionHeading": "説明",
			"tagsHeading": "タグ",
			"citationsHeading": "引用文献",
			"playing": "再生中"
		},
		"a11y": {
			"artwork": "{{title}}のアートワーク",
			"playEpisode": "エピソードを再生、{{duration}}",
			"pauseEpisode": "エピソードを一時停止",
			"play": "再生",
			"pause": "一時停止",
			"addToQueue": "キューに追加",
			"removeFromQueue": "キューから削除",
			"addBookmark": "ブックマーク",
			"removeBookmark": "ブックマークを解除",
			"seekBar": "シークバー",
			"skipPrevious": "前のトラックへ",
			"skipNext": "次のトラックへ",
			"rewind": "{{seconds}}秒巻き戻す",
			"fastForward": "{{seconds}}秒早送りする",
			"playbackSpeed": "再生速度{{speed}}x"
		}
	}
}
